<template>
    <div class="shadow-box" style="margin-top: 22px;" v-loading="loadAll">
        <el-table :data="menuData" row-key="id" :tree-props="{children: 'subMenu'}" :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }">
            <el-table-column prop="name" label="名称" min-width="100" align="left">
                <template slot-scope="{row}">
                    <span v-if="row.level == 1 && !(row.subMenu && row.subMenu.length)" class="block"></span>{{ row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="path" label="路径" min-width="100" align="left"></el-table-column>
            <el-table-column prop="actionNames" label="功能" min-width="150" align="left"></el-table-column>
            <el-table-column prop="modelName" label="ModelName" min-width="100" align="left"></el-table-column>
            <el-table-column prop="sort" label="顺序" min-width="70" align="left"></el-table-column>
            <el-table-column label="操作" min-width="100" align="center">
                <template slot-scope="{row}">
                    <el-button type="text" style="padding: 0;" @click="moreOperation('edit', row)">编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button type="text" style="padding: 0;" @click="moreOperation('permission', row)">授权</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-popconfirm title="确定删除此菜单吗？" @confirm="deleteMenuItem(row)">
                        <el-button slot="reference" type="text" style="padding: 0;">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新增/编辑 -->
        <el-drawer :title="`${editId ? '编辑' : '新增'}菜单`" :visible.sync="addEditDrawer" size="35rem" direction="rtl" custom-class="add-drawer" :wrapperClosable="false">
            <el-form ref="addEditFormRef" :model="addEditForm" :rules="addEditRules" label-position="left" label-width="120px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="addEditForm.name" placeholder="请输入菜单名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="路径" prop="path">
                    <el-input v-model="addEditForm.path" placeholder="请输入菜单路径" clearable></el-input>
                </el-form-item>
                <el-form-item label="ModelName" prop="modelName">
                    <el-input v-model="addEditForm.modelName" placeholder="请输入ModelName" clearable></el-input>
                </el-form-item>
                <el-form-item label="父级菜单" prop="parentId">
                    <el-tree v-if="addEditDrawer" ref="menuTree" :data="menuData" :props="{ children: 'subMenu', label: 'name' }" node-key="id" :check-strictly="true"
                        :default-checked-keys="addEditCheckedIds" show-checkbox accordion @check-change="selectParent" style="margin-top: 8px;"></el-tree>
                </el-form-item>
                <el-form-item label="权限功能">
                    <el-checkbox-group v-model="addEditForm.actionList" style="margin-top: 5px; line-height: 30px;">
                        <el-checkbox :label="item.id" v-for="item in permissionOptions" :key="item.id">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="顺序" prop="sort">
                    <el-input v-model.number="addEditForm.sort" placeholder="请输入菜单顺序" clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button :loading="loadSaveAddEdit" @click="confirmAddEdit" class="save-btn">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close :visible="addEditDrawer" right="35rem" @close="addEditDrawer = false"></drawer-close>
        </el-drawer>

        <!-- 授权设置 -->
        <el-drawer title="授权设置" :visible.sync="permissionDrawer" size="35rem" direction="rtl" custom-class="add-drawer">
            <el-form ref="permissionFormRef" :model="permissionForm" :rules="permissionRules" label-position="left" label-width="120px">
                <el-form-item label="选择">
                    <el-radio-group v-model="permissionForm.type">
                        <el-radio :label="2">按类型</el-radio>
                        <el-radio :label="1">按用户</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="用户" prop="userIdList" v-if="permissionForm.type == 1">
                    <el-select v-model="permissionForm.userIdList" placeholder="请选择用户" filterable multiple style="width: 100%;">
                        <el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户类型" prop="userTypeList" v-else-if="permissionForm.type == 2">
                    <el-select v-model="permissionForm.userTypeList" placeholder="请选择用户类型" filterable multiple style="width: 100%;">
                        <el-option v-for="item in userTypeOptions.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限功能">
                    <el-checkbox-group v-model="permissionForm.actionList" style="margin-top: 1px;">
                        <el-checkbox :label="item.id" v-for="item in permissioActionList" :key="item.id">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="">
                    <el-button :loading="loadSavePermission" @click="confirmPermission" class="save-btn">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close :visible="permissionDrawer" right="35rem" @close="permissionDrawer = false"></drawer-close>
        </el-drawer>
    </div>
</template>

<script>
import { findMenuList, addMenu, updateMenu, deleteMenu, findAllUserList, authority } from '@/api/setting/index.js';
import { mapState } from 'vuex';

export default {
    name: 'menuManage',
    data() {
        return {
            loadAll: false,
            menuData: [],
            // 新增/编辑
            addEditDrawer: false,
            editId: '',
            addEditCheckedIds: [], // el-tree默认勾选的数组
            addEditForm: {
                name: '',
                path: '',
                modelName: '',
                parentId: '',
                actionList: [],
                sort: '',
            },
            addEditRules: {
                name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
                modelName: [{ required: true, message: "请输入ModelName", trigger: "blur" }],
            },
            permissionOptions: [
                { id: 1, name: '显示' },
                { id: 2, name: '查看' },
                { id: 3, name: '添加' },
                { id: 4, name: '修改' },
                { id: 5, name: '删除' },
                { id: 6, name: '导入' },
                { id: 7, name: '导出' },
                { id: 8, name: '其他' },
            ],
            loadSaveAddEdit: false,
            // 授权设置
            permissionDrawer: false,
            userOptions: [],
            permissioActionList: [],
            permissionForm: {
                menuId: '',
                type: 1,
                userIdList: [],
                userTypeList: [],
                actionList: [],
            },
            permissionRules: {
                userIdList: [{ required: true, message: "请选择用户", trigger: "blur" }],
                userTypeList: [{ required: true, message: "请选择用户类型", trigger: "blur" }],
            },
            loadSavePermission: false,
        }
    },
    computed: {
        ...mapState(['userTypeOptions'])
    },
    created() {
        this.fetchMenuData();
        this.getUserOptions();
    },
    methods: {
        // 获取菜单列表数据
        fetchMenuData() {
            this.loadAll = true;
            findMenuList().then(res => {
                this.loadAll = false;
                this.menuData = res.data;
                this.menuData.forEach(item => {
                    item.level = 1;
                    item.actionIds = item.actionList.map(x => Number(x.id));
                    item.actionNames = item.actionList.map(x => x.name)?.join('、');
                    if (item.subMenu && item.subMenu.length) {
                        this.handleChildData(item.subMenu);
                    }
                })
            }).catch((err) => {
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        handleChildData(data) {
            data.forEach(item => {
                item.actionIds = item.actionList.map(x => Number(x.id));
                item.actionNames = item.actionList.map(x => x.name)?.join('、');
                if (item.subMenu && item.subMenu.length) {
                    this.handleChildData(item.subMenu);
                }
            })
        },
        // 操作菜单
        deleteMenuItem(row) {
            deleteMenu({ id: row.id }).then(res => {
                this.fetchMenuData();
                this.$MessageBox.MessageSuccess(res.msg);
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        moreOperation(type, item) {
            if (type == "edit") {
                this.addEditDrawer = true;
                this.editId = item.id;
                this.addEditForm = {
                    name: item.name,
                    path: item.path,
                    modelName: item.modelName,
                    actionList: item.actionIds,
                    sort: item.sort,
                    parentId: item.parentId,
                };
                this.$nextTick(() => {
                    if (item.parentId === '0') {
                        this.addEditCheckedIds = [];
                        this.$refs.menuTree.setCheckedKeys([]);
                    } else {
                        this.addEditCheckedIds = [item.parentId];
                    }
                    this.$refs.addEditFormRef?.clearValidate();
                })
            } else if (type == "add") {
                this.addEditDrawer = true;
                this.editId = "";
                this.addEditForm = {
                    name: '',
                    path: '',
                    modelName: '',
                    actionList: [],
                    parentId: '',
                    sort: '',
                };
                this.$nextTick(() => {
                    this.addEditCheckedIds = [];
                    this.$refs.menuTree.setCheckedKeys([]);
                    this.$refs.addEditFormRef?.clearValidate();
                })
            } else if (type == "permission") {
                this.permissionDrawer = true;
                this.permissioActionList = item.actionList;
                this.permissionForm = {
                    menuId: item.id,
                    type: 1,
                    userIdList: [],
                    userTypeList: [],
                    actionList: [],
                };
                this.$nextTick(() => {
                    this.$refs.permissionFormRef?.clearValidate();
                })
            }
        },
        // 树形组件选择父级菜单
        selectParent(data, checked) {
            if (checked) {
                this.$refs.menuTree.setCheckedKeys([data.id]); // 重新设置当前节点的选中状态
            } else {
                // 这里可以添加逻辑来处理点击同一节点取消选择的场景，例如：
                if (this.$refs.menuTree.getCheckedKeys().includes(data.id)) {
                    this.$refs.menuTree.setCheckedKeys([]); // 清空所有选中项（包括当前项）
                }
            }
        },
        // 确认新增/编辑菜单
        confirmAddEdit() {
            this.loadSaveAddEdit = true;
            this.$refs.addEditFormRef.validate(valid => {
                if (valid) {
                    let checkedKeys = this.$refs.menuTree.getCheckedKeys();
                    this.addEditForm.parentId = checkedKeys.length ? checkedKeys[0] : '';
                    let req = this.editId ? updateMenu : addMenu;
                    req({
                        id: this.editId ? this.editId : undefined,
                        ...this.addEditForm,
                        actionList: this.addEditForm.actionList.map(x => { return { id: x } }),
                    }).then(() => {
                        this.loadSaveAddEdit = false;
                        this.addEditDrawer = false;
                        this.$MessageBox.MessageSuccess("保存成功！菜单将在重新登录后生效");
                        this.fetchMenuData();
                    }).catch((err) => {
                        this.loadSaveAddEdit = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    });
                } else {
                    this.loadSaveAddEdit = false;
                    return;
                }
            })
        },
        // 确认授权设置
        confirmPermission() {
            this.loadSavePermission = true;
            this.$refs.permissionFormRef.validate(valid => {
                if (valid) {
                    let params = { ...this.permissionForm };
                    if (params.type == 1) {
                        delete params.userTypeList;
                    } else if (params.type == 2) {
                        delete params.userIdList;
                    }
                    delete params.type;
                    authority(params).then(res => {
                        this.loadSavePermission = false;
                        this.permissionDrawer = false;
                        this.$MessageBox.MessageSuccess(res.msg);
                    }).catch(err => {
                        this.loadSavePermission = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    })
                } else {
                    this.loadSavePermission = false;
                    return;
                }
            })
        },
        // 所有用户的列表
        getUserOptions() {
            findAllUserList().then(res => {
                this.userOptions = res.data;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.block {
    display: inline-block;
    width: 22px;
}
.save-btn {
    width: 6.9rem;
    height: 2.38rem;
    background: $primary-btn-color;
    color: #fff;
    border: none;
    border-radius: 6px;
    display: inline-block;
    margin: 0.5rem 0 3rem;
    cursor: pointer;
}
</style>